import React from 'react';
import PropTypes from 'prop-types';

import Box from '@redbubble/design-system/react/Box';

import styles from './TabList.css';

const TabList = ({ children }) => {
  return <Box className={styles.container}>{children}</Box>;
};

TabList.propTypes = {
  children: PropTypes.node
};

export default TabList;
